import React from 'react';
import { SectionHeader } from './SectionHeader';
import { Button } from './Button';
export function CargoTable() {
  // Representative rows for Part 393 Subpart I - Cargo Securement
  const tableData = [{
    reg: '§393.100',
    subpart: 'General rules for protection against shifting and falling cargo',
    question: 'Does the vehicle have adequate cargo securement?',
    yes: 'Yes',
    link: 'http://www.fmcsa.dot.gov'
  }, {
    reg: '§393.102',
    subpart: 'What are the minimum performance criteria for cargo securement devices and systems?',
    question: 'Are devices meeting minimum criteria?',
    yes: '',
    link: 'http://www.fmcsa.dot.gov'
  }, {
    reg: '§393.104',
    subpart: 'What standards must cargo securement devices and systems meet in order to satisfy the requirements of this subpart?',
    question: 'Do devices meet standards?',
    yes: 'Yes',
    link: 'http://www.fmcsa.dot.gov'
  }, {
    reg: '§393.106',
    subpart: 'What are the general requirements for securing articles of cargo?',
    question: 'Are general requirements met?',
    yes: 'Yes',
    link: 'http://www.fmcsa.dot.gov'
  }, {
    reg: '§393.110',
    subpart: 'What else do I have to do to determine the minimum number of tiedowns?',
    question: 'Is the minimum number of tiedowns used?',
    yes: '',
    link: 'http://www.fmcsa.dot.gov'
  }, {
    reg: '§393.114',
    subpart: 'What are the requirements for front end structures used as part of a cargo securement system?',
    question: 'Does the front end structure meet requirements?',
    yes: 'Yes',
    link: 'http://www.fmcsa.dot.gov'
  }];
  return <section className="py-16 bg-legal-light border-t border-legal-border" data-id="element-14">
      <div className="max-w-legal-container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-15">
        <SectionHeader id="Cargo-Transportation" number="03" title="CARGO TRANSPORTATION" data-id="element-16" />

        <div className="mb-8" data-id="element-17">
          <h3 className="text-2xl font-bold text-legal-dark mb-4" data-id="element-18">
            Federal Motor Carrier Safety Regulations, Part 393
          </h3>
          <p className="text-legal-gray mb-8" data-id="element-19">
            Improperly secured cargo can cause catastrophic accidents. The
            following table outlines key regulations regarding cargo securement.
          </p>
        </div>

        {/* Desktop Table (Hidden on small screens) */}
        <div className="hidden md:block overflow-x-auto bg-white rounded-lg shadow-sm border border-legal-border mb-12" data-id="element-20">
          <table className="w-full text-left border-collapse" data-id="element-21">
            <thead data-id="element-22">
              <tr className="bg-legal-dark text-white" data-id="element-23">
                <th className="p-4 font-semibold border-b border-gray-700 w-32" data-id="element-24">
                  Regulation #
                </th>
                <th className="p-4 font-semibold border-b border-gray-700" data-id="element-25">
                  Subpart title
                </th>
                <th className="p-4 font-semibold border-b border-gray-700" data-id="element-26">
                  Question text
                </th>
                <th className="p-4 font-semibold border-b border-gray-700 text-center w-24" data-id="element-27">
                  Yes
                </th>
                <th className="p-4 font-semibold border-b border-gray-700 w-24" data-id="element-28">
                  Link
                </th>
              </tr>
            </thead>
            <tbody data-id="element-29">
              {tableData.map((row, idx) => <tr key={idx} className={idx % 2 === 0 ? 'bg-white' : 'bg-gray-50'} data-id="element-30">
                  <td className="p-4 border-b border-legal-border font-medium text-legal-dark" data-id="element-31">
                    {row.reg}
                  </td>
                  <td className="p-4 border-b border-legal-border text-legal-gray" data-id="element-32">
                    {row.subpart}
                  </td>
                  <td className="p-4 border-b border-legal-border text-legal-gray" data-id="element-33">
                    {row.question}
                  </td>
                  <td className="p-4 border-b border-legal-border text-center font-bold text-legal-red" data-id="element-34">
                    {row.yes}
                  </td>
                  <td className="p-4 border-b border-legal-border" data-id="element-35">
                    <a href={row.link} className="text-blue-600 hover:underline text-sm" target="_blank" rel="noopener noreferrer" data-id="element-36">
                      View
                    </a>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        {/* Mobile Cards (Hidden on medium+ screens) */}
        <div className="md:hidden space-y-4 mb-12" data-id="element-37">
          {tableData.map((row, idx) => <div key={idx} className="bg-white p-5 rounded-lg shadow-sm border border-legal-border" data-id="element-38">
              <div className="flex justify-between items-start mb-3" data-id="element-39">
                <span className="inline-block bg-legal-dark text-white px-2 py-1 rounded text-sm font-bold" data-id="element-40">
                  {row.reg}
                </span>
                {row.yes && <span className="text-legal-red font-bold" data-id="element-41">YES</span>}
              </div>
              <h4 className="font-bold text-legal-dark mb-2 text-sm" data-id="element-42">
                {row.subpart}
              </h4>
              <p className="text-legal-gray text-sm mb-4" data-id="element-43">{row.question}</p>
              <a href={row.link} className="text-blue-600 hover:underline text-sm font-medium" target="_blank" rel="noopener noreferrer" data-id="element-44">
                View Regulation
              </a>
            </div>)}
        </div>

        {/* CTA */}
        <div className="bg-white border-2 border-legal-red rounded-lg p-8 text-center shadow-sm" data-id="element-45">
          <h3 className="text-2xl font-bold text-legal-dark mb-4" data-id="element-46">
            Questions About Cargo-Related Truck Accident Liability?
          </h3>
          <p className="text-legal-gray mb-6" data-id="element-47">
            If shifting or falling cargo caused your accident, multiple parties
            may be liable.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-48">
            <Button href="11014.html" variant="primary" icon="mail" data-id="element-49">
              Contact Us
            </Button>
            <Button href="tel:18007085433" variant="outline" icon="phone" data-id="element-50">
              Call Now
            </Button>
          </div>
        </div>
      </div>
    </section>;
}